module.exports = __webpack_public_path__ + "images/icons/flags/IN-8fd7c38d.svg";